import {
  LocalOfferLocation,
  LocalOfferMarker,
  LocationTypeEnum,
  VendorItem,
} from '@varo/graphql-schema-types';

export const mapVendorItemToLocalOfferLocation = (
  v: VendorItem,
): LocalOfferLocation | null => {
  const lat = v?.location?.latitude;
  const lng = v?.location?.longitude;

  if (
    typeof lat !== 'number' ||
    typeof lng !== 'number' ||
    !Number.isFinite(lat) ||
    !Number.isFinite(lng)
  ) {
    return null;
  }

  const address = {
    __typename: 'Address',
    addressLine1: v?.address?.addressLine1 ?? null,
    addressLine2: v?.address?.addressLine2 ?? null,
    city: v?.address?.city ?? null,
    state: v?.address?.state ?? null,
    zip: v?.address?.zip ?? null,
    country: v?.address?.country ?? null,
    externalId: v?.address?.externalId ?? null,
  };

  const coordinate = {
    __typename: 'GeoCoordinate',
    latitude: lat,
    longitude: lng,
  };

  const offer = {
    __typename: 'LocalOfferLocation',
    id: `${v?.merchantId ?? v?.id ?? 'vendor'}`,
    type: LocationTypeEnum.LocalOffer,
    name: v?.name ?? '',
    address,
    addressCopy: v?.address?.addressLine1 ?? undefined,
    coordinate,
    distance: v?.distanceFormatted ?? undefined,
    marker: v?.marker ?? LocalOfferMarker.Merchant,
    label: v?.label ?? undefined,
    sourceMerchantId: v?.merchantId ?? undefined,
    cashbackAmount: v?.cashbackValue ?? undefined,
    industry: undefined,
    logoImage: v?.logoUrl ?? undefined,
    offerId: v?.id ?? undefined,
    offerType: undefined,
    originalPrice: v?.pricingTier?.originalPrice?.formatted ?? undefined,
    discountedPrice: v?.pricingTier?.disountedPrice?.formatted ?? undefined,
    offerSource: v?.offerSource ?? undefined,
    merchantId: v?.merchantId ?? undefined,
    onClick: v?.onClick ?? undefined,
  } as unknown as LocalOfferLocation;

  return offer;
};
